import React from "react";
import { useTranslation } from "react-i18next";

export const CheckboxCustomFieldOptions = () => {
	const { t } = useTranslation();

	return (
		<>
			<tr>
				<td className="action" />
				<td className="text-muted ps-0">{t("common.word.yes", { ns: "lib" })}</td>
			</tr>
			<tr>
				<td className="action" />
				<td className="text-muted ps-0">{t("common.word.no", { ns: "lib" })}</td>
			</tr>
		</>
	);
};
